import React, { useContext, useEffect, useRef, useState } from 'react'
import { adminUserManageLink } from '../../constants/endspoints'
import { NavLink } from 'react-router-dom'
import { AppContexte } from '../../contexts/context'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { fetchUserById, updateUser, updateUserPassword } from '../../api/user'
import { toast } from 'react-toastify'
import Modal from 'react-responsive-modal'
import { useForm } from 'react-hook-form'

const UserManagement = () => {

    const { decodedToken } = useContext(AppContexte)

    const queryClient = useQueryClient();

    const {register,formState: { errors },handleSubmit} = useForm()

    const [formData, setFormData] = useState({ name:'', email:'', job:''});
    const [selectedData, setSelectedData] = useState()
    const [pwd, setPwd] = useState("") 
    const [showPassword, setShowPassword] = useState(false)
    const [pwdSuccess, setPwdSuccess] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)

    // Fetch single user by ID
    const { data: user, isLoading: isFetchingUser } = useQuery({
        queryKey: ['user', decodedToken?.id],
        queryFn: () => fetchUserById(decodedToken?.id),
        enabled: !!decodedToken?.id,
    });


    const reset = () => {
        setFormData({name:user?.data?.name, email:user?.data?.email, job:user?.data?.job})
    }

    useEffect(() => {
        if(user?.data){
            setFormData({name:user?.data?.name, email:user?.data?.email, job:user?.data?.job})
        }
    }, [user]);




    // Mutation pour gérer la modification des infos personnelles
    const toastUpdate = useRef(null);
    const updateMutation = useMutation({
        mutationFn: (user) => updateUser(user.userId, user.updatedData),
        onMutate: ()=>{
            toastUpdate.current = toast.loading(`Modification en cours...`, { 
                position: 'top-right',
            });
        },
        onSuccess: () => {
            toast.dismiss(toastUpdate.current);
            toastUpdate.current = toast.success(`Modifié avec succès`, {
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
            });
            setSelectedData()
            queryClient.invalidateQueries({ queryKey: ["user"] });
            toastUpdate.current = null;
        },
        onError: (err) => {
            toast.dismiss(toastUpdate.current);
            toastUpdate.current = toast.error("Une erreur est survenue: "+err.message, {
                isLoading: false,
                hideProgressBar: false,
                closeOnClick: true,
            });
            toastUpdate.current = null;
        },
    });

    const modify = () => {
        if (formData.name === "" || formData.email === "" || formData.job === "") {
            toast.error("Le champs ne peut pas être vide", {
                position: 'top-right',
                autoClose: 5000,
                closeOnClick: true,
            });
            return;
        }
        updateMutation.mutate({userId:user?.data?.id, updatedData:formData})
    }




    // Mutation pour gérer la modification de mot de passe
    const toastUpPwd = useRef(null);
    const updatePwdMutation = useMutation({
        mutationFn: updateUserPassword,
        onMutate: ()=>{
            toastUpPwd.current = toast.loading(`Modification en cours...`, { 
                position: 'top-right',
            });
        },
        onSuccess: (res) => {
            toast.dismiss(toastUpPwd.current);
            toastUpPwd.current = toast.success(res?.data?.message, {
                isLoading: false,
                autoClose: false,
                closeOnClick: true,
            });            
            setPwdSuccess(res?.data?.message)
            toastUpPwd.current = null;
        },
        onError: (err) => {
            toast.dismiss(toastUpPwd.current);
            toastUpPwd.current = toast.error("Une erreur est survenue: "+err.message, {
                isLoading: false,
                hideProgressBar: false,
                closeOnClick: true,
                autoClose: false,
            });
            toastUpPwd.current = null;
        },
    });

    const modifyPwd = () => {
        if (pwd === "") {
            toast.error("Veuillez renseigner le Nouveau Mot de Passe", {
                position: 'top-right',
                autoClose: 5000,
                closeOnClick: true,
            });
            return;
        }
        updatePwdMutation.mutate({email: user?.data?.email, plainPassword: pwd})
    }





    return (
        <div>
            <h1 className='fs-3 fw-bold mb-2'>Mon compte</h1>

            <div className='bg-black mt-4 rounded-3 p-2 shadow'>
                {/* Submenu */}
                {
                    decodedToken && decodedToken?.roles[0] === "ROLE_ADMIN" &&
                    <div className="d-flex justify-content-start align-items-center mb-3 menu">
                        <NavLink to={adminUserManageLink} className='d-flex align-items-center px-2 py-1 mb-2 nav-link border bordercolor-primary rounded-3'>
                            <i className="fa-light fa-users-gear me-2 text-white"></i>
                            <span className=' fs-9s text-white'>Tous les utilisateurs</span>
                        </NavLink>
                    </div>
                }

                {/* User Info */}
                <div className='user-info mt-2'>
                    <h2 className='fs-5 fw-bold mb-3 text-center'>Informations personnelles</h2>
                    {
                        isFetchingUser?
                        <div className='d-flex justify-content-center'>
                            <table className='table table-dark table-sm table-striped placeholder-wave p-2' style={{ width: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td className='fs-9s' style={{ width: 'auto' }}>Nom:</td>
                                        <td><p className='fs-9s placeholder col-12 bgcolor-primary mb-0' style={{width:"10rem"}}></p></td>
                                    </tr>
                                    <tr>
                                        <td className='fs-9s' style={{ width: 'auto' }}>Email:</td>
                                        <td><p className='fs-9s placeholder col-12 bgcolor-primary mb-0' style={{width:"10rem"}}></p></td>
                                    </tr>
                                    <tr>
                                        <td className='fs-9s' style={{ width: 'auto' }}>Poste:</td>
                                        <td><p className='fs-9s placeholder col-12 bgcolor-primary mb-0' style={{width:"10rem"}}></p></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        :
                        <div className='table-responsive d-flex justify-content-center'>
                            <table className='table table-dark table-sm table-striped' style={{ width: 'auto' }}>
                                <tbody>
                                    <tr>
                                        <td className='fs-9s px-2' style={{ width: 'auto' }}>Nom:</td>
                                        <td className='fs-9s pe-2' style={{ width: 'auto' }}>
                                            {
                                                selectedData === 1 ? 
                                                    <input 
                                                        type='text' 
                                                        onChange={(e)=>setFormData({ ...formData, name: e.target.value })} 
                                                        value={formData.name} 
                                                        className='form-control shadow-none bg-black fs-9s text-white py-0 px-1'
                                                    />
                                                :user?.data?.name
                                            }
                                        </td>
                                        <td className='fs-9s pe-2 d-flex align-items-center' style={{ width: 'auto' }}>
                                            <button 
                                                className={`border-0 rounded bgcolor-primary px-2 py-1 text-white fs-9s ${selectedData === 1 ? "fa-regular fa-check" : "fa-light fa-user-edit"}`}
                                                disabled={updateMutation.isPending}
                                                onClick={()=>selectedData !== 1 ? (setSelectedData(1), reset()) : modify()}>
                                            </button>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className='fs-9s px-2' style={{ width: 'auto' }}>Email:</td>
                                        <td className='fs-9s pe-2' style={{ width: 'auto' }}>
                                            {
                                                selectedData === 2 ? 
                                                    <input 
                                                        type='text' 
                                                        onChange={(e)=>setFormData({ ...formData, email: e.target.value })} 
                                                        value={formData.email} 
                                                        className='form-control shadow-none bg-black fs-9s text-white py-0 px-1'
                                                    />
                                                :user?.data?.email
                                            }
                                        </td>
                                        <td className='fs-9s pe-2 d-flex align-items-center' style={{ width: 'auto' }}>
                                            <button 
                                                className={`border-0 rounded bgcolor-primary px-2 py-1 text-white fs-9s ${selectedData === 2 ? "fa-regular fa-check" : "fa-light fa-user-edit"}`}
                                                disabled={updateMutation.isPending}
                                                onClick={()=>selectedData !== 2? (setSelectedData(2), reset()) : modify()}>
                                            </button>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className='fs-9s px-2' style={{ width: 'auto' }}>Poste:</td>
                                        <td className='fs-9s pe-2' style={{ width: 'auto' }}>
                                            {
                                                selectedData === 3 ? 
                                                    <input 
                                                        type='text' 
                                                        onChange={(e)=>setFormData({ ...formData, job: e.target.value })} 
                                                        value={formData.job} 
                                                        className='form-control shadow-none bg-black fs-9s text-white py-0 px-1'
                                                    />
                                                :user?.data?.job
                                            }
                                        </td>
                                        <td className='fs-9s pe-2 d-flex align-items-center' style={{ width: 'auto' }}>
                                            <button 
                                                className={`border-0 rounded bgcolor-primary px-2 py-1 text-white fs-9s ${selectedData === 3 ? "fa-regular fa-check" : "fa-light fa-user-edit"}`}
                                                disabled={updateMutation.isPending}
                                                onClick={()=>selectedData !== 3? (setSelectedData(3), reset()) : modify()}>
                                            </button>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    }
                </div>


                <div className=' mt-4'>
                    <p 
                        role='button'
                        onClick={()=>setIsModalOpen(true)}
                        className='color-primary fs-9s fst-italic text-decoration-underline mb-1'
                    >
                        Modifier le Mot de Passe
                    </p>
                </div>
            </div>


            <Modal 
                open={isModalOpen} 
                onClose={()=>updatePwdMutation.isPending ? null : (setIsModalOpen(false), setPwd(""), setPwdSuccess(false))} 
                center 
                classNames={{modal:"bg-black text-white border"}} 
                closeIcon={<i className='fa fa-xmark text-white'></i>}
                focusTrapped={false}
            >

                {
                    !pwdSuccess?
                    <div className='p-4'>
                        <h2 className='fs-5 fw-bold mb-3 text-center'>Modifier le mot de passe</h2>
                        <div className='d-flex flex-column justify-content-center'>
                            <div className='position-relative'>
                                <input 
                                    type={showPassword?'text':'password'} 
                                    {...register("password", {
                                        required: "Mot de passe requis",
                                        minLength: {
                                            value: 9,
                                            message: "Doit avoir au moins 09 caractères",
                                        },
                                        pattern: {
                                            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{9,}$/,
                                            message:
                                                "Minimun 9 caractères, 1 majuscule, 1 miniscule, 1 caractère special",
                                        },
                                    })}
                                    onChange={(e)=>setPwd(e.target.value)} 
                                    value={pwd} 
                                    autoComplete="new-password"
                                    className='form-control shadow-none bg-black fs-9s text-white py-1 px-2'
                                    placeholder='Nouveau Mot de Passe'
                                />
                                <p 
                                    role='button' 
                                    className={`fa-regular ${showPassword?'fa-eye':'fa-eye-slash'} text-white-50 position-absolute mb-0 fs-9s`} 
                                    style={{bottom: "7px", right: "10px", zIndex:"10"}}
                                    onClick={()=>setShowPassword(!showPassword)}
                                ></p>
                            </div>
                            {errors.password && <span className="fs-8s text-danger">{errors.password.message}</span>}
                        </div>
                        <div className='d-flex justify-content-center mt-4'>
                            <button 
                                className='border-0 rounded bgcolor-primary px-2 py-1 text-white fs-9s d-flex align-items-center'
                                disabled={updatePwdMutation.isPending}
                                onClick={handleSubmit(modifyPwd)}
                            >
                                <i className='fa fa-pen-to-square me-2'/>
                                {updatePwdMutation.isPending ? "Chargement..." : "Modifier"}
                            </button>
                        </div>
                    </div>
                    :<p className='fs-9s text-white'>{pwdSuccess}</p>
                }

            </Modal>
        </div>
    )
}

export default UserManagement